import { DecorationSet } from '@codemirror/view';

/**
 * Extracts the starting positions of the current foldings, and returns them as an
 * array to be consumed/saved later
 * @param decorationSet - DecorationSet
 */
export function calculateFolding(decorationSet: DecorationSet): number[] {
  const values: number[] = [];
  const cursor = decorationSet.iter(0);

  for (let i = 0; i < decorationSet.size; i++) {
    values.unshift(cursor.from);
    cursor.next();
  }

  return values;
}
